import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function PublishNotification(projectId, notificationId) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_NOTIFICATION}/xpmgr/notifications/publish/${projectId}/${notificationId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}
